import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}


/* codex-prs-best-watercolour-link-fix start */
(function() {
  var articlePath = '/blogs/knowledge/the-best-watercolour-paints-in-2026-an-honest-guide-from-someone-whos-used-them-all';
  if (window.location.pathname !== articlePath) return;
  var hrefMap = {
    'rubens-watercolor-paper-block-7-6-x10-6-cold-pressed-watercolor-pad-20-sheets-of-200gsm-white-watercolor-paper-premium-cotton-sketchbook-ideal-for-watercolor-gouache-acrylic': 'https://www.paulrubensshop.com/products/rubens-watercolor-paper-block-7-67-x10-63-cold-pressed-watercolor-pad-20-sheets-of-140lb-300gsm-white-watercolor-paper-premium-100-cotton-sketchbook-ideal-for-watercolor-gouache-acrylic-1',
    'rubens-watercolor-brush-set-3pcs-professional-soft-synthetic-squirrel-paint-brushes-short-handles-for-watercolor-gouache-ink-painting-sizes-2-4-6': 'https://www.paulrubensshop.com/products/rubens-watercolor-brush-set-3pcs-professional-soft-synthetic-squirrel-paint-brushes-short-handles-for-watercolor-gouache-ink-painting-sizes-2-4-7',
    'rubens-watercolor-paint-set-16-colors-full-pan-solid-artist-watercolors-with-removable-amp-refillable-pans-highly-pigmented-watercolor-portable-art-painting-set-for-beginner-artist-adults': 'https://www.paulrubensshop.com/products/rubens-watercolor-paint-set-24-vivid-colors-transparent-watercolor-artist-solid-watercolor-paint-professional-travel-water-color-portable-art-paint-supplier-white-box-for-beginner-student-adult',
    'rubens-watercolor-paint-set-24-colors-full-pan-solid-artist-watercolors-with-removable-amp-refillable-pans-highly-pigmented-watercolor-portable-art-painting-set-for-beginner-artist-adults': 'https://www.paulrubensshop.com/products/rubens-watercolor-paint-set-24-vivid-colors-transparent-watercolor-artist-solid-watercolor-paint-professional-travel-water-color-portable-art-paint-supplier-white-box-for-beginner-student-adult'
  };
  var imgMap = {
    '71RV-TC6EEL._AC_SY300_SX300_QL70_FMwebp.webp': 'https://cdn.shopify.com/s/files/1/0675/1934/8845/files/71fdj7ixaNL._AC_SL1500.jpg?v=1775031770',
    '81ts2LNPpEL._AC_SY300_SX300_QL70_FMwebp.webp': 'https://cdn.shopify.com/s/files/1/0675/1934/8845/files/71fdj7ixaNL._AC_SL1500.jpg?v=1775031770',
    '51FgojskSDL._AC_SY300_SX300_QL70_FMwebp.webp': 'https://cdn.shopify.com/s/files/1/0675/1934/8845/files/51FgojskSDL._AC_SL1000.jpg?v=1776687397',
    '81UTzwKCI4L._AC_SY300_SX300_QL70_FMwebp.webp': 'https://cdn.shopify.com/s/files/1/0675/1934/8845/files/91xvPG9McaL._AC_SL1500_d2c20733-5067-4596-afc8-6f5b74f21c32.jpg?v=1776677431'
  };
  var textMap = [
    ['Paul Rubens 16-color', 'Paul Rubens 24 Vivid Colors'],
    ['Paul Rubens 16-Color Full Pan Set ($25.99)', 'Paul Rubens 24 Vivid Colors Set ($55.99)'],
    ['16-Color Full Pan Set ($25.99)', '24 Vivid Colors Set ($55.99)'],
    ['16-Color Full Pan Solid', '24 Vivid Colors Solid Set'],
    ['16-Color Full Pan', '24 Vivid Colors'],
    ['16 full-size solid pans', '24 vivid solid colors'],
    ['Each pan removes individually and refills', 'Rich color range for everyday painting'],
    ['Each pan removes individually', 'Artist-grade color range'],
    ['replace colors that run out, not the whole set', 'enough colors for portraits, florals, landscapes, and daily practice'],
    ['Focused 16-color palette accelerates mixing skill development', 'Balanced 24-color palette gives beginners room to mix without becoming overwhelming']
  ];
  function replaceTextValue(value) {
    textMap.forEach(function(pair) { value = value.split(pair[0]).join(pair[1]); });
    return value;
  }
  function runFix() {
    document.querySelectorAll('a[href]').forEach(function(a) {
      var href = a.getAttribute('href') || '';
      Object.keys(hrefMap).forEach(function(key) { if (href.indexOf(key) !== -1) a.setAttribute('href', hrefMap[key]); });
    });
    document.querySelectorAll('img').forEach(function(img) {
      var src = img.getAttribute('src') || '';
      Object.keys(imgMap).forEach(function(key) { if (src.indexOf(key) !== -1) img.setAttribute('src', imgMap[key]); });
      if (img.getAttribute('srcset')) img.removeAttribute('srcset');
      if (img.alt) img.alt = replaceTextValue(img.alt);
    });
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(node) {
      var next = replaceTextValue(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runFix); else runFix();
  window.addEventListener('load', runFix);
})();
/* codex-prs-best-watercolour-link-fix end */
